import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  galleryRoot: {
    display: "flex",
    gap: 20,
    width: "100%",
    alignItems: "stretch",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: 16,
    },
  },
  mainImageBox: {
    flex: "1 1 0",
    // minWidth: 0,
    maxWidth: "400px",
    borderRadius: "8px",
    overflow: "hidden",
    background: theme.palette.background.paper,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    aspectRatio: "16/9",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      aspectRatio: "16/10",
    },
  },
  mainImage: {
    width: "100%",
    height: "100%",
    borderRadius: "8px",
  },
  verticalImageBox: {
    flex: "0 0 210px",
    minWidth: 160,
    maxWidth: 240,
    height: 340,
    borderRadius: "8px",
    overflow: "hidden",
    background: theme.palette.background.paper,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      flex: "unset",
      minWidth: 0,
      maxWidth: "100%",
      height: 180,
      margin: "12px 0",
    },
  },
  verticalImage: {
    width: "100%",
    height: "100%",
    borderRadius: "8px",
  },
  gridImagesBox: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr",
    gap: 12,
    flex: "0 0 340px",
    minWidth: 180,
    maxWidth: 340,
    width: "100%",
    height: "340px",
    [theme.breakpoints.down("sm")]: {
      flex: "unset",
      minWidth: 0,
      maxWidth: "100%",
      height: 180,
      gap: 8,
    },
  },
  gridImageWrapper: {
    position: "relative",
    borderRadius: "8px",
    overflow: "hidden",
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  gridImage: {
    width: "100%",
    height: "100%",
    borderRadius: "8px",
  },
}));
